import { useEffect, useState } from "react";

import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Grupos from "./Grupos";
import Acessos from "./Acessos";
import Dados from "./Dados";
import { UsuarioInterface } from "../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import {
    faDice,
    faMousePointer,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { GetUsuarioInfoController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";

export default function EditarUsuario(props: ModalEditarPropsInterface) {
    const [user, setUser] = useState<UsuarioInterface>(props.USER);
    const [access, setAccess] = useState<UsuarioInterface>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        updateUser(props.USER.ID_USUARIO);
    }, [props.USER.ID_USUARIO]);

    const updateUser = (idUsuario: number) => {
        setLoading(true);
        GetUsuarioInfoController(idUsuario)
            .then((res) => {
                setUser({
                    ...res,
                    FUNCOES: [],
                    MODULOS: [],
                    GRUPOS: [],
                    TELAS: [],
                });
                setAccess(res);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="tab-content" id="GrupoTools">
            <div
                className="tab-pane fade active show"
                id="DadosUsuario"
                role="tabpanel"
                aria-labelledby="DadosUsuario"
            >
                <Dados
                    {...props}
                    user={user}
                    updateUser={updateUser}
                    loading={loading}
                    setShow={props.setShow}
                />
            </div>
            <div
                className="tab-pane fade"
                id="GruposUsuario"
                role="tabpanel"
                aria-labelledby="GruposUsuario"
            >
                <Grupos
                    idUsuario={props.USER.ID_USUARIO}
                    updateUser={updateUser}
                />
            </div>
            <div
                className="tab-pane fade"
                id="AcessosUsuario"
                role="tabpanel"
                aria-labelledby="AcessosUsuario"
            >
                <Acessos access={access || props.USER} />
            </div>
        </div>
    );
}

export interface ModalEditarPropsInterface {
    USER: UsuarioInterface;
    updateList: () => void;
    setShow: (value: React.SetStateAction<boolean>) => void;
}

export function EditarUsuarioHeader(name: string) {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title"
            >
                <h3 className="card-label">{name}</h3>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#UserTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#DadosUsuario"
                            data-toggle="tab"
                            data-target="#DadosUsuario"
                            role="tab"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faDice} />
                            </span>
                            <span className="nav-text">Dados</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#GruposUsuario"
                            data-toggle="tab"
                            data-target="#GruposUsuario"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faUsers} />
                            </span>
                            <span className="nav-text">Grupos</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#AcessosUsuario"
                            data-toggle="tab"
                            data-target="#AcessosUsuario"
                        >
                            <span className="nav-icon">
                                <FontAwesomeIcon icon={faMousePointer} />
                            </span>
                            <span className="nav-text">Acessos</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}
